export default __webpack_public_path__ + "static/media/icon_privacy_home_choice_base.8384e84a.svg";